import PageContainer from "@/common/components/PageContainer";
import { AspectRatio, Box, Container, Divider, Grid, Text, Title, createStyles } from "@mantine/core";
import { motion } from "framer-motion";
import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";

import { useFetchEcompage } from "@/apis/queryFunctions/ecompagesFunctions";
import TitleCus from "@/common/Typography/TitleCus";
import useWindowSize from "@/hooks/useWindowSize";
import { useLocalContext } from "@/setup/locale-provider";
import appendImageUrlFromAPI from "@/utils/appendImageUrlFromAPI";
import sanitizeDOMData from "@/utils/sanitizeDOMData";

export default function Info({
  title = "Why to choose",
  label,
  picture = "https://zengroup.com.vn/wp-content/uploads/2022/04/du-an-nha-mat-tien-Q12-1024x768.jpg",
  index,
}) {
  let link = picture || null;
  if (link != null) {
    if (link && link.indexOf("http") < 0) {
      link = `${process.env.server_url_report}${link}?access_token=${process.env.public_token}&trustkey=${process.env.trustkey}`;
    }
  }
  const {isTablet} = useWindowSize();
  const { getLabel } = useLocalContext();
  const { locale } = useRouter();
  const { data } = useFetchEcompage("trang-xuat-khau-viet-thien", locale);
  const infoXuatkhau = (data?.add_on_data||[]).slice(0,5);
  const infoXuatkhau2 = (data?.add_on_data_2||[]).slice(0,5);
  
  return (
    <div>
      <Box component="section" sx={{background:"#FFF"}}>
        <Container>
        <Box
            sx={{ paddingBottom: 30 }}
        >
          <Divider my="xs" 
                label={
                  <Title
                    order={1}
                    size={isTablet?24:36}
                    weight={950}
                    align="center"
                    pb={10}
                    sx={{ /* paddingBottom: 45, */ color: "#12854F" /* theme.colors.main[5] */ }}
                    >
                    {sanitizeDOMData(infoXuatkhau2?.[0]?.title)}
                  </Title>} 
                
                labelPosition="center" 
          />

              <Grid pt={20} justify="space-between" align="start">
                {infoXuatkhau.map((info, index) => (
                  <Grid.Col xs={12} md={3} align="center" key={index}>
                    <motion.div whileHover={{ scale: 1.05 }}>
                      <Box>
                        <Image
                          src={appendImageUrlFromAPI({
                            src: info?.picture,
                            size: "l",
                          })}
                          alt={`${info?.title}`}
                          width={128}
                          height={128}
                        />
                        <div>
                          <Text size={36} weight={950} style={{}}>
                            {sanitizeDOMData(info?.title)}
                          </Text>
                          <Text size={24} weight={450}>
                            {sanitizeDOMData(info?.content)}
                          </Text>
                        </div>
                      </Box>
                    </motion.div>
                  </Grid.Col>
                ))}
              </Grid>


        </Box>
        </Container>
      </Box> 

      <Box component="section" sx={{background:"#FFF"}}>
        <Container size="md">
        <Box /* sx={{ paddingBottom: 80 }} */>
          
                  <Text
                    size={36}
                    weight={950}
                    align="left"
                    c="#212F3B"
                    ta="justify"
                    sx={{lineHeight:"28px" }}
                    >
                    {sanitizeDOMData(infoXuatkhau2?.[0]?.content)}
                  </Text>
      
        </Box>
        </Container>
        <Container size="xl">
        <Box
                  sx={{
                    position: "relative",
                    aspectRatio: "1.5",  
                  }}
                >
                  <Image
                    src={appendImageUrlFromAPI({ src: infoXuatkhau2[0]?.picture })}
                    alt={`${infoXuatkhau2[0]?.title}`}
                    layout="fill"
                    objectFit="contain"
                  />
                </Box>
          
        </Container>
      </Box>
{/*         <Container size="xl">
        <Box
                  sx={{
                    position: "relative",
                    aspectRatio: "1",  
                  }}
                >
                  <Image
                    src={appendImageUrlFromAPI({ src: infoXuatkhau2[0]?.picture, size: "l" })}
                    layout="fill"
                    objectFit="contain"
                  />
                </Box>
          
        </Container> */}
      
    </div>  
  );
}
